'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_layout = get_layout;
exports.get_library = get_library;

var _layout = require('./library/standard/layout');

var _layout2 = _interopRequireDefault(_layout);

var _standard = require('./library/standard');

var _standard2 = _interopRequireDefault(_standard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get_layout(type) {
  var layoutProps = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return layoutProps[type] || _layout2.default[type];
}

function get_library() {
  var type = arguments.length <= 0 || arguments[0] === undefined ? 'text' : arguments[0];
  var libraryProps = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return libraryProps[type] || _standard2.default[type];
}

var api = {
  get_layout: get_layout,
  get_library: get_library
};

exports.default = api;


/** WEBPACK FOOTER **
 ** ../biro/lib/gui.js
 **/